export enum ContextNames {
    row = 'row',
}

type EventProcesses = 'startProcess';

export interface ComponentEventInstance {
    component: any;
    data: any;
    event: any;
    type: EventProcesses;
}

const getDataGridRowData = (componentEventInstance: ComponentEventInstance) => {
    return componentEventInstance.data;
};

export const ProcessContextDefenition = (
    contextName: ContextNames,
    componentEventInstance: ComponentEventInstance,
) => {
    switch (contextName) {
        case ContextNames.row:
            return getDataGridRowData(componentEventInstance);
        default:
            return componentEventInstance.data;
    }
};
